import { render, staticRenderFns } from "./WebTwoCourseActionAdd.vue?vue&type=template&id=f5d9fce8&scoped=true&"
import script from "./WebTwoCourseActionAdd.vue?vue&type=script&lang=js&"
export * from "./WebTwoCourseActionAdd.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoCourseActionAdd.vue?vue&type=style&index=0&id=f5d9fce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d9fce8",
  null
  
)

export default component.exports